module.exports = __webpack_public_path__ + "media/images/lb/334-19269ed4355def9fed15e0d72cb21f17.svg";